export const pathMatches = (location, path) => {
    let basePath = location.pathname.split('/')[1];
    // If it matches the first slug or the whole thing e.g. page/terms
    return path === basePath || '/' + path === location.pathname;
}